import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  font-weight: bold;\n  color: ",
        ";\n  text-transform: uppercase;\n  border: none;\n  background: none;\n  text-decoration: underline;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  background: white;\n  width: 100%;\n  height: 100%;\n  padding-bottom: 23px;\n  font-family: ",
        ";\n  color: ",
        ";\n  background-color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 16px;\n  padding-top: 32px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  margin-bottom: 0;\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: 600;\n  color: ",
        ";\n\n  ",
        " {\n    font-size: 20px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-weight: 300;\n  color: ",
        ";\n  letter-spacing: auto;\n\n  ",
        " {\n    font-size: 16px;\n    font-weight: 400 !important;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  max-height: 66vw;\n  overflow: auto;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 18px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: space-between;\n  padding: 0 18px;\n  padding-top: 18px;\n\n  & > p {\n    font-weight: normal;\n    letter-spacing: 2px;\n    text-transform: uppercase;\n    color: ",
        ";\n    margin-bottom: 8px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  color: rgb(227 44 43);\n  margin: 18px;\n  margin-top: 0;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ResizeObserver } from "@juggle/resize-observer";
import * as SessionStorage from "@purple-dot/browser-sdk/src/libraries/session-storage";
import useEventListener from "@use-it/event-listener";
import React, { useEffect, useRef, useState } from "react";
import styled, { createGlobalStyle, ThemeProvider } from "styled-components";
import { ReadyMadePersistedCheckout } from "../../../custom-server/scripts/src/client-checkout";
import { FullStorySnippetString } from "../../components/common/fullstory";
import { BelowMobile } from "../../components/common/media-queries";
import { useAsyncWithRequest } from "../../components/common/use-async-with-request";
import useMeasure from "../../components/common/use-measure";
import * as CheckoutApi from "../../components/EmbeddedApp/checkout-api";
import Item from "../../components/EmbeddedApp/EmbeddedCart/Item";
import { OpenCheckoutButton } from "../../components/EmbeddedApp/EmbeddedCart/OpenCheckoutButton";
import { useAnalytics } from "../../components/EmbeddedApp/PageTypes/IframePage/AnalyticsProvider";
import IframePage from "../../components/EmbeddedApp/PageTypes/IframePage/EmbeddedPage";
import * as ParentPage from "../../components/EmbeddedApp/parent-page";
import { useTranslation } from "../../components/use-translation";
import expressPage from "../../webserver-page";
function Cart(param) {
    var view = param.view;
    var persistedCheckoutRef = useRef(ReadyMadePersistedCheckout(view));
    var persistedCheckout = persistedCheckoutRef.current;
    var analytics = useAnalytics();
    var ref = useState(null), checkout = ref[0], setCheckout = ref[1];
    var ref1 = useParentPageResizeEffect();
    var ref2 = useState(null), error = ref2[0], setError = ref2[1];
    var t = useTranslation().t;
    useEventListener("message", function(event) {
        var ref;
        if ((ref = event.data) === null || ref === void 0 ? void 0 : ref.type) {
            if (event.data.type === "CART_SHOWN") {
                analytics.track("Cart Viewed");
            }
            if (event.data.type === "CART_HIDDEN") {
                analytics.track("Cart Dismissed");
            }
        }
    });
    useEffect(function() {
        var elem = document.body;
        var resizeObserver = new ResizeObserver(function() {
            window.parent.postMessage({
                meta: {
                    placementType: "cart",
                    type: "window-size-changed"
                },
                data: {
                    width: elem.offsetWidth,
                    height: elem.offsetHeight
                }
            }, "*");
        });
        resizeObserver.observe(elem);
        setInterval(function() {
            var checkoutSession = SessionStorage.getItem("checkoutSession");
            setCheckout(checkoutSession);
            var fullstoryElem = document.querySelector("#fullstory-snippet");
            if (checkoutSession && !fullstoryElem) {
                var script = document.createElement("script");
                script.id = "fullstory-snippet";
                script.innerHTML = FullStorySnippetString;
                document.body.appendChild(script);
            }
        }, 500);
    }, []);
    var RemoveLineItemTask = useAsyncWithRequest({
        deferFn: function() {
            var _ref = _async_to_generator(function(param) {
                var _param, lineItemId, checkoutId;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _param = _sliced_to_array(param, 1), lineItemId = _param[0].lineItemId;
                            return [
                                4,
                                persistedCheckout.id()
                            ];
                        case 1:
                            checkoutId = _state.sent();
                            return [
                                2,
                                CheckoutApi.removeItemFromCheckout([
                                    {
                                        checkoutId: checkoutId,
                                        lineItemId: lineItemId
                                    }
                                ])
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        onResolve: function(data) {
            if (data.lineItems.length === 0) {
                persistedCheckout.clear();
                ParentPage.postCartCleared();
            } else {
                persistedCheckout.update(data);
                setCheckout(data);
            }
            ParentPage.postRemovedFromCart(data);
        },
        onReject: function(err) {
            setError(err.originalMessage);
        }
    });
    var apiKey = view.apiKey;
    // Temp workaround: if checkout.state === COMPLETED, the shape of the
    // resulting object is different, so just return nothing instead of crashing :(
    return /*#__PURE__*/ _jsxs(IframePage, {
        head: view,
        useFullstory: false,
        children: [
            /*#__PURE__*/ _jsx(GlobalCSS, {
                globalCSS: view.globalCSS
            }),
            /*#__PURE__*/ _jsx(ThemeProvider, {
                theme: view.theme,
                children: /*#__PURE__*/ _jsx(CartContainer, {
                    ref: ref1,
                    children: checkout && checkout.state !== "COMPLETED" && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsxs(HeaderSection, {
                                children: [
                                    /*#__PURE__*/ _jsx(Title, {
                                        children: checkout.isAddingToPreorder ? t("translation:checkout.add-to-pre-order") : t("translation:self-service.pre-order:your-pre-order")
                                    }),
                                    /*#__PURE__*/ _jsx(Subtitle, {
                                        "data-testid": "dispatch-dates",
                                        children: checkout.dispatching.datesDisplay
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(LineItemsContainer, {
                                children: [
                                    checkout.lineItems.map(function(lineItem) {
                                        return /*#__PURE__*/ _jsx(Item, {
                                            lineItem: lineItem,
                                            RemoveLineItemTask: RemoveLineItemTask,
                                            canRemove: checkout.lineItems.length > 1
                                        }, lineItem.id);
                                    }),
                                    error && /*#__PURE__*/ _jsx(CartError, {
                                        error: error
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(TotalContainer, {
                                children: [
                                    /*#__PURE__*/ _jsx("p", {
                                        children: t("translation:checkout.subtotal")
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        children: checkout.subtotal.display
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(ButtonPosition, {
                                children: /*#__PURE__*/ _jsx(OpenCheckoutButton, {
                                    onClick: function() {
                                        analytics.track("Cart Viewed");
                                        onCheckoutClicked({
                                            apiKey: apiKey
                                        });
                                    },
                                    children: t("translation:checkout.checkout")
                                })
                            }),
                            /*#__PURE__*/ _jsx(CloseButtonPosition, {
                                children: /*#__PURE__*/ _jsx(TextButton, {
                                    onClick: function() {
                                        analytics.track("Cart Dismissed");
                                        ParentPage.postCloseCartClicked();
                                    },
                                    children: t("translation:checkout.close")
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}
function useParentPageResizeEffect() {
    var ref = _sliced_to_array(useMeasure(), 2), ref1 = ref[0], bounds = ref[1];
    useEffect(function() {
        postResizeMessage({
            width: bounds.width,
            height: bounds.height
        });
    }, [
        bounds.width,
        bounds.height
    ]);
    return ref1;
}
function onCheckoutClicked(param) {
    var apiKey = param.apiKey;
    var checkoutSession = SessionStorage.getItem("checkoutSession");
    if (checkoutSession) {
        ParentPage.postCartCheckoutClicked({
            apiKey: apiKey,
            checkoutId: checkoutSession.id
        });
    }
}
function postResizeMessage(param) {
    var width = param.width, height = param.height;
    ParentPage.postResizeMessage({
        id: "purple-dot-cart",
        width: width,
        height: height
    });
}
var GlobalCSS = createGlobalStyle(_templateObject(), function(param) {
    var globalCSS = param.globalCSS;
    return globalCSS || "";
});
var CloseButtonPosition = styled.div(_templateObject1());
var TextButton = styled.button(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.text.header.color;
});
var CartContainer = styled.div(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.text.body.fontFamily;
}, function(param) {
    var theme = param.theme;
    return theme.text.body.color;
}, function(param) {
    var theme = param.theme;
    return theme.modal.backgroundColor;
});
var HeaderSection = styled.div(_templateObject4());
var Title = styled.h1(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.title.fontSize;
}, function(param) {
    var theme = param.theme;
    return theme.title.fontSize;
}, function(param) {
    var theme = param.theme;
    return theme.text.header.color;
}, BelowMobile);
var Subtitle = styled.h2(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.text.body.fontFamily;
}, function(param) {
    var theme = param.theme;
    return theme.text.body.color;
}, BelowMobile);
var LineItemsContainer = styled.ul(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.borderColor;
});
var ButtonPosition = styled.div(_templateObject8());
var TotalContainer = styled.div(_templateObject9(), function(param) {
    var theme = param.theme;
    return theme.text.header.color;
});
var CartError = styled(function(param) {
    var className = param.className, error = param.error;
    return /*#__PURE__*/ _jsx("div", {
        className: className,
        "data-testid": "cart-error",
        children: error
    });
})(_templateObject10());
export default expressPage(Cart);
